import React from 'react'
import { Link } from 'react-router-dom'

class ProjectTile extends React.Component {
    constructor(props){
        super(props);
        this.mouseEnter = this.mouseEnter.bind(this);
        this.mouseLeave = this.mouseLeave.bind(this);
        this.state = {
            start: props.project.start_time
        }
    }

    mouseEnter() {   
        var playPromise =this.refs.video.play()

      if (playPromise !== undefined) {
        playPromise
          .then(_ => {
            // Automatic playback started!
            // Show playing UI.
            console.log("audio played auto");
          })
          .catch(error => {
            // Auto-play was prevented
            // Show paused UI.
            console.log("playback prevented");
          });
      }
    }
    
    mouseLeave() {
        this.refs.video.pause();
        this.refs.video.currentTime = this.state.start;
    }

    componentDidMount(){
        console.log(this.state);
        this.refs.video.currentTime = this.state.start;
    }

    render(){
        const project = this.props.project;
        var poster=null;
        if(project.poster != undefined) {
            poster = `${process.env.PUBLIC_URL}/images/${project.poster}`
        }

        return(
            <Link to={`/projects/${project.id}`}>
                <div className="project-tile gc" onMouseEnter={this.mouseEnter} onMouseLeave={this.mouseLeave}>
                    <video className="r-1 d-1-13" ref="video" playsInline={true} no-controls="true" title={project.title}>
                    <source src={project.video}></source>
                    </video>
                    {/* <p className="flex">{project.title}</p> */}
                    <h2 className="r-1 d-1-13 flex flex-c">{project.title}</h2>

                </div>
            </Link>
        )
    }
}

export default ProjectTile